import { accessRole } from "../../../../helpers/access_role"
import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button,
    Alert,
    UncontrolledAlert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import { AvForm } from "availity-reactstrap-validation"
import {ConfirmAlert} from "../../../../helpers/ui/alert";
import apiResponse from '../../../../../src/services/apiResponse';
import IndexBloc from '../index/Blocs/IndexBloc'

var reformatOptions = function(raw, label, value) {
  // console.log(raw)
  return raw.map(function(data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

class IndexView extends Component {

  indexBloc = new IndexBloc()

    constructor(props) {
      let periode_ = React.createRef();
      let eselon_ = React.createRef();

      super(props)
      this.state = {
        assessment_matrix : this.props.matrixid,
        msMatrix : [{}],
        eselonOption : [
          {
            echelon_name : "",
            echelon_uuid : ""
          }
        ],
        periodeOption : [
          {
            period_assess_name : "",
            period_assess_uuid : ""
          }
        ],
        dataForm : null,
        stperiode : "",
        steselon : "",
        stmatrixlevel : "",
        modal : false,
        detailmatrix : [{}]
      }
    }
    loadPeriod = async () => {
      await this.indexBloc.fetchPeriod({})
    }
    loadEselon = async () => {
      await this.indexBloc.fetchEselon({})
    }
    loadMsMatrix = async () => {
      const query = {
          uuid: this.props.uuid
      }
      // console.log(query)
      await this.indexBloc.fetchMatrix(query)
    }
    loadMsassesment = async (mxlvl) => {
      const query = {
          periode: this.state.stperiode,
          eselon: this.state.steselon,
          matrixlevel: mxlvl,
      }
      console.log(query)
      await this.indexBloc.fetchMatrixassesmentlist(query)
    }
    click_matrix = (matrix_level) =>{
      // alert(matrix_level)
      let mxlvl = matrix_level;
      this.setState({
        stmatrixlevel: mxlvl,
      });
      this.setState({
        modal: !this.state.modal
      });
      console.log(this.state.stmatrixlevel)
      this.loadMsassesment(mxlvl)
    }
    toggle = ()=> {
      this.setState({
        modal: !this.state.modal
      });
    }
    submitData = async () => {
      this.setState({
        loading: true
      })
      await this.indexBloc.fetchSearch(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
      let forState = {}
      e.preventDefault()
      // console.log(values)
      // return 

      this.setState({
        dataForm: values,
        stperiode: values.periode,
        steselon: values.eselon,
        // confirm: true
      })
      console.log(this.state.stperiode);
      console.log(this.state.steselon);
      this.submitData();
    }
    
    componentDidMount() {
      this.loadPeriod()
        this.indexBloc.periodChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        
                        this.setState({
                            periodeOption: reformatOptions(
                                response, 
                                'period_assess_name',
                                'period_assess_uuid'
                            )
                        })
                        // console.log('periode')
                        // console.log(this.state.periodeOption)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
      this.loadEselon()
        this.indexBloc.eselonChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        
                        this.setState({
                          eselonOption: reformatOptions(
                                response, 
                                'echelon_name',
                                'echelon_uuid'
                            )
                        })
                        // console.log('eselon')
                        // console.log(this.state.periodeOption)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
      this.loadMsMatrix()
      this.indexBloc.acMatrixChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log(response)
                      this.setState({
                          msMatrix : response
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })

      this.indexBloc.searchMatrixChannel.subscribe((result) => {
        // console.log(result)
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response
                    this.setState({
                        msMatrix : response,
                        loading: false,
                        // success: true
                    })
                }
                break
            case apiResponse.ERROR:
                this.setState({
                    loading: false,
                    success: false
                })
                break
            default:
                break
        }
      })
      this.indexBloc.mxListChannel.subscribe((result) => {
        // console.log(result)
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response
                    console.log(response)
                    this.setState({
                      detailmatrix : response,
                        loading: false,
                        // success: true
                    })
                }
                break
            case apiResponse.ERROR:
                this.setState({
                    loading: false,
                    success: false
                })
                break
            default:
                break
        }
      })
      
  }
    render() {
      return (
        <Fragment>
          <Card>
            <CardBody className="">
              <CardTitle className="h4 mb-4">
              LAPORAN MANAJEMEN TALENTA (TALENT MANAGEMENT BOX)
              <hr />
              </CardTitle>
              <div className=""  style={{padding:'20px',marginLeft:'50px'}}>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                <Row>
                  <Col sm={1}>
                    <label htmlFor="">Periode</label>
                  </Col>
                  <Col sm={3}>
                    <CustomSelect 
                        name="periode"
                        errorMessage="Pilih Periode"
                        placeholder="Pilih Periode"
                        options={this.state.periodeOption}
                        defaultValue={this.state.periodeOption[0].value}
                        // isAvForm={false}
                    />
                  </Col>
                  </Row>
                  <br />
                  <Row>
                  <Col sm={1}>
                    <label htmlFor="">Eselon</label>
                  </Col>
                  <Col sm={3}>
                    <CustomSelect 
                        name="eselon"
                        errorMessage="Pilih Eselon"
                        placeholder="Pilih Eselon"
                        options={this.state.eselonOption}
                        // isAvForm={false}
                    />
                  </Col>
                  <Col sm={3}><button type="submit" className="btn btn-primary"><i className="uil-search-alt"></i>Cari</button></Col>
                </Row>
                </AvForm>
                <br /> 
                <Row>
                    <Col sm={1} style={{backgroundColor:'lavender'}}>
                    <div align={'center'} valign={'center'}>
                        <h4 style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left',marginTop:'238px'}}>KINERJA</h4>
                    </div>
                    </Col>
                    <Col sm={1}>
                    <div align={'center'} valign={'center'}>
                        <b style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left',marginBottom:'50px',marginTop:'20px'}}><u>DIATAS EKSPEKTASI</u></b>
                        <br />
                        <b style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left',marginBottom:'50px'}}><u>SESUAI EKSPEKTASI</u></b>
                        <br />
                        <b style={{'writing-mode':'vertical-rl','transform':'rotate(180deg)','align':'left'}}><u>DIBAWAH EKSPEKTASI</u></b>
                    </div>
                    </Col>
                    <Col sm={6}>
                    <Row>
                        {
                        this.state.msMatrix.map((data,index)=>{
                            return(
                              <Col sm={4} style={{'margin-right':'-13px', border:'solid 0.5px #ebebeb'}}>
                                <a href="javascript:void(0)" onClick={()=>this.click_matrix(data.matrix_level)}>
                                  <div
                                  color="secondary"
                                  className="alert-border alert-dismissible fade show mt-0 px-4 mb-0 text-center"
                                  
                                  >
                                  {
                                    this.state.assessment_matrix == data.matrix_level ? <i className="uil uil-check-circle d-block display-4 mt-2 mb-3 text-info"></i> : <h5 className="d-block display-4 mt-2 mb-3">{data.matrix_level}</h5>
                                  }
                                  <p><b>{data.count_matrix}&nbsp;({(data.count_matrix!=0)?Math.round((data.count_matrix/data.count_assesment)*100):0}%)</b></p>
                                  <p style={{color:"black"}}>{data.matrix_desc}</p>
                                  </div>
                                </a>
                              </Col>
                            )

                        })

                        }
                        </Row>
                        
                    <br />
                    <br />
                    <Row>
                        <Col sm={4} className="text-center">
                        <b><u>RENDAH</u></b>
                        </Col>
                        <Col sm={4} className="text-center">
                        <b><u>MENENGAH</u></b>
                        </Col>
                        <Col sm={4} className="text-center">
                        <b><u>TINGGI</u></b>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} className="mt-4" style={{backgroundColor:'lavender',padding:'20px'}}>
                        <div align={'center'} valign={'center'}>
                            <h4>POTENSIAL</h4>
                        </div>
                        </Col>
                    </Row>
                    </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <ConfirmAlert
              confirmTitle="Konfirmasi!"
              confirmInfo="Apakah anda yakin akan menyimpan data ini?"

              loadingTitle="Mencari data..."
              loadingInfo="Tunggu beberapa saat"

              successTitle="Berhasil!"
              successInfo="Data berhasil disimpan"

              failedTitle="Gagal!"
              failedInfo="Data gagal disimpan"

              showConfirm={this.state.confirm}
              showLoading={this.state.loading}
              showSuccess={this.state.success}
              showFailed={this.state.failed}

              response={this.confirmResponse}
          />
          <Modal isOpen={this.state.modal} size='xl'>
          <ModalHeader>Laporan Assesment
          </ModalHeader>
          <ModalBody>
            <table className="table table-bordered">
              <thead style={{background:'lavender'}}>
                <tr>
                  <th>No.</th>
                  <th>Periode Assesment</th>
                  <th>Nama Pegawai</th>
                  <th>Jabatan</th>
                  <th>Assesor</th>
                  <th>Kinerja Pegawai</th>
                  <th>JPM</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.detailmatrix.map((data,index)=>{
                    return(
                        <tr>
                          <td className="text-center">{(index+1)}</td>
                          <td>{data.period_assess_name}</td>
                          <td>{data.employee_full_name}</td>
                          <td>{data.position_name}</td>
                          <td>{data.assessment_assessor_name}</td>
                          <td>{data.performance_name} ({data.performance_code})</td>
                          <td>{data.assessment_jpm}</td>
                        </tr>
                )

              })

              }
              </tbody>
            </table>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-default" onClick={()=>this.toggle()}>Tutup</button>
          </ModalFooter>
          </Modal>
        </Fragment>
      )
    }
  }
  export default IndexView